module.exports = __webpack_public_path__ + "static/media/business-04.292b81b2.png";